<template>
  <section>
    <!--工具条-->
    <el-col :span="6" class="toolbar">
      <el-input placeholder="用户昵称" size="small" v-model="query" @change="search">
        <el-button slot="append" icon="search" @click="search"></el-button></el-input>
    </el-col>

    <el-table :data="tableData"
              v-loading="listLoading">
      <el-table-column
        label="用户昵称"
        prop="name"
        align="center">
        <template scope="scope">
            <router-link :to="'/user/info/' + scope.row.usid">{{scope.row.name}}</router-link>
        </template>
      </el-table-column>
      <el-table-column
        label="提现编号"
        prop="tixian_num"
        align="center">
      </el-table-column>
      <el-table-column
        label="当前天然豆"
        prop="cur_coins"
        align="center">
      </el-table-column>
      <el-table-column
        label="提现天然豆"
        prop="tixian_coins"
        align="center">
      </el-table-column>
      <el-table-column
        label="提现状态"
        align="center">
        <template scope="scope">
          <div>{{tixianStatus[scope.row.tixian_status]}}</div>
        </template>
      </el-table-column>
      <el-table-column
        label="创建时间"
        prop="create_time"
        align="center">
      </el-table-column>
      <el-table-column
        label="操作"
        align="center">
        <template scope="scope">
            <el-button size="small" type="primary" v-if="scope.row.tixian_status == 0" @click="tixian(scope.row.id)">处理提现</el-button>
            <div v-else>已处理</div>
        </template>
      </el-table-column>
    </el-table>

    <el-col :span="0" class="toolbar_page">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="[10, 15, 20, 30]"
        :page-size="pageSize"
        layout="sizes, prev, pager, next"
        :total="total">
      </el-pagination>
    </el-col>
  </section>
</template>

<script>
  import config from '../../config';
  import basicdata from '../../static/config/basicdata.js';

  export default {
    data() {
      return {
        tableData: [],
        total:0,
        page:1,
        pageSize:15,
        listLoading: false,
        query: '',
        tixianStatus: basicdata.tixianStatus,
      }
    },
    methods: {
      //分页方法
      handleSizeChange(size) {
        this.pageSize = size;
        this.search();
      },
      handleCurrentChange(page) {
        this.page = page;
        this.search();
      },
      search() {
        this.getSearch(this.query);
      },
      getSearch(query) {
        this.listLoading = true;
        this.$axios.post(config.api_url + '/tixian/page', {
          "page": this.page,
          "size": this.pageSize,
          "query": query
        }).then(response => {
          let data = response.data;
          if(data.state) {
            this.total = data.count;
            this.tableData = data.msg;
            this.listLoading = false;
          }
        }).catch(error => {
          console.log(error);
          this.$message({
            message: '获取数据异常，请联系管理员',
            type: 'error'
          });
        })
      },
      //确认提现
      tixian(id) {
        this.$confirm('是否确认提现？', '提示', {}).then(() => {
            this.$axios.post(config.api_url + '/tixian/'+id
            ).then(response => {
                if(response.data.state) {
                    this.$message({
                        message: '提现成功！',
                        type: 'success'
                    });
                } else {
                    this.$message({
                        message: '提现失败，请联系管理员',
                        type: 'warning'
                    });
                }
                this.search();
            }).catch(error => {
                console.log(error);
                this.$message({
                    message: '提现异常，请联系管理员',
                    type: 'error'
                });
            });
        });
      }
    },
    created() {
      this.search();
    }
  }
</script>

<style scoped>
  .rightsearch{
    float: right;
  }
  .user-font {
    font-weight: 600;
    font-size: 15px;
    color: #48576a;
  }
</style>



// WEBPACK FOOTER //
// Tixian.vue?0d73e5b4